import * as React from "react";
import { Redirect } from "react-router-dom";

const GotoBookmakers: React.FC = () => <Redirect to="/bookmakers" />;

export default GotoBookmakers;
